// extracted by mini-css-extract-plugin
export default {"input":"search_input__-xcm4"};